//-------------------------------------------------------------
//  Vue Custom Directives
//-------------------------------------------------------------

// Use: <component v-focus="boolean"></component>
Vue.directive('focus', function (el, binding) {
    if (binding.value) {
        el.focus();
    }
});

// Use: <component v-click-outside:exception="method"></component>
// Exception = ID of element to be ignored
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (binding.arg) {
                var exception = '#' + binding.arg;
            }

            if (!(el == event.target || el.contains(event.target)) && (!exception || !event.target.closest(exception))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});